<template>
  <div class="mb">
    <div class="tolead_con">
      <div class="flex_bet_h tools_titmod">
        <span class="tools_tit">文案提取 </span>
        <img
          src="../../assets/images/img2/offlogin.png"
          class="tools_off"
          @click="hide"
        />
      </div>
      <div class="tolead_tit flex_bet">
        <div class="flex_ali">
          <img src="../../assets/images/img2/tolead.png" class="tolead_icon" />
          <div v-if="name">
            <p>{{ name }}</p>
            <p class="tolead_text">大小:{{ size }}</p>
          </div>
          <div v-else>未选择文件</div>
        </div>
        <div class="tolead_btn flex_cen">
          <input
            type="file"
            class="upload"
            multiple="multiple"
            accept="audio"
            @change="setFile($event)"
          />
          <span>上传文件</span>
        </div>
      </div>
      <p class="tolead_tot">识别内容</p>
      <textarea class="tolead_textarea" v-model="text"></textarea>
      <div class="flex_bet">
        <div class="tolead_bbtn flex_cen" @click="copyText">复制文字</div>
        <div class="tolead_bbtn flex_cen" @click="goMake">立即配音</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      file: null, // 当前选择的本地文件
      name: "", //选择文件的名称
      size: 0, //选择文件的大小
      text: "" //识别文本
    };
  },
  methods: {
    // 关闭点击
    hide() {
      this.$emit("hide");
    },
    // 选择本地文件
    setFile(e) {
      let file = e.target.files[0];
      this.file = file;
      this.name = file.name;
      this.size = this.$globalFun.formatFileSize(file.size);
      let type = file.name.split(".")[file.name.split(".").length - 1];
      if (type.indexOf("jpg") >= 0 || type.indexOf("png") >= 0) {
        console.log("识别图片");
        this.getOcr(file);
      } else if (type.indexOf("txt") >= 0) {
        this.recognitFile(file, res => {
          console.log(res);
          this.text = res.data.model;
        });
      } else {
        this.$alert(
          "该功能只支持：jpg、png、txt格式的文件，当前选择的文件格式不支持！"
        );
      }
    },
    // 图片识别文字
    getOcr(file) {
      const loading = this.$loading({
        lock: true,
        text: "识别中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
        customClass: "make_loding"
      });
      this.$globalFun.getFile(file, res => {
        console.log(res);
        let json = {
          image: res.data.model.bgmusicurl,
          type: 0
        };
        let url = "https://scan.shipook.com/v2app/scan/image/ocr";
        this.$request.postHttp(json, url, response => {
          loading.close();
          console.log(response);
          let content = response.model.common.reduce((text, item) => {
            text += item.text + "\n";
            return text;
          }, "");
          this.text = content;
        });
      });
    },
    // 识别txt文件内容
    recognitFile(file, callback) {
      // 这个接口不加解密
      let url =
        "https://pysq.shipook.com/v2app/peiyin/file/getTextFromTextFile";
      let data = new FormData();
      const loading = this.$loading({
        lock: true,
        text: "识别中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
        customClass: "make_loding"
      });
      data.append("file", file);
      this.$http
        .post(url, data)
        .then(response => {
          loading.close();
          callback(response);
        })
        .catch(error => {});
    },
    // 复制文字
    copyText() {
      var textarea = document.getElementsByClassName('tolead_textarea')[0]
      textarea.select();
      document.execCommand("copy", true);
      window.getSelection().empty()
      this.$message('复制成功');
    },
    // 立即配音事件
    goMake(){
      this.$emit('goMake',this.text)
    }
  }
};
</script>
<style scoped>
.tolead_btn input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.tolead_bbtn {
  width: 261px;
  height: 52px;
  background: #ef475d;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
}
.tolead_bbtn:last-child {
  background-color: #333;
}
.tolead_textarea {
  width: 100%;
  height: 340px;
  background-color: #f8f8f8;
  border-radius: 10px;
  margin-top: 16px;
  padding: 16px;
  margin-bottom: 30px;
}
.tolead_tot {
  font-size: 18px;
  margin-top: 20px;
}
.tolead_btn {
  width: 80px;
  height: 33px;
  border-radius: 6px;
  border: 1px solid #333333;
  font-size: 12px;
  position: relative;
}
.tolead_text {
  font-size: 12px;
  color: #999;
}
.tolead_icon {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.tools_titmod {
  padding-bottom: 20px;
}
.tolead_tit {
  width: 100%;
  height: 72px;
  border-radius: 10px;
  background-color: #f8f8f8;
  padding: 16px;
}
.tools_off {
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: all 0.4s;
}
.tools_off:hover {
  transform: rotate(180deg);
}
.tools_tit {
  font-size: 18px;
}
.tolead_con {
  width: 586px;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/make/tolead.vue